//* 반복 예약 삭제 조건 설정 모달

import Modal from "react-modal";
import { Btns, CancelBtn, Container, Heading, OptionItem, Options, Section } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import { useEffect, useState } from "react";
import { RepeatReservationDeleteModalProps, RepeatReservationDeleteOption } from "./types";
import { set } from "lodash";

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    width: "400px",
    borderRadius: "20px",
    transform: "translate(-50%, -50%)",
    padding: 0,
    margin: 0,
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};

export default function RepeatReservationDeleteModal(props: RepeatReservationDeleteModalProps) {
  const { modalIsOpen, closeModal, onDelete } = props;
  const [selectedOption, setSelectedOption] = useState<RepeatReservationDeleteOption>(
    RepeatReservationDeleteOption.THIS_SCHEDULE
  );

  const handleDelete = () => {
    onDelete(selectedOption);
    closeModal();
  };

  useEffect(() => {
    if (modalIsOpen) setSelectedOption(RepeatReservationDeleteOption.THIS_SCHEDULE);
  }, [modalIsOpen]);

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
      <Container>
        <CancelBtn>
          <UI.IconButton.Normal
            type="primary"
            icon="x"
            size={20}
            color="var(--alias-color-label-normal)"
            onClick={closeModal}
          />
        </CancelBtn>
        <Heading>
          <UI.Typography type="heading02" fontStyle="bold" color="var(--alias-color-label-neutral)">
            반복 예약 삭제 조건 설정
          </UI.Typography>
        </Heading>
        <Section>
          <Options>
            <OptionItem onClick={() => setSelectedOption(RepeatReservationDeleteOption.THIS_SCHEDULE)}>
              <UI.Radio selected={selectedOption === RepeatReservationDeleteOption.THIS_SCHEDULE} />
              <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
                이 일정
              </UI.Typography>
            </OptionItem>
            <OptionItem
              onClick={() => setSelectedOption(RepeatReservationDeleteOption.THIS_SCHEDULE_AND_FUTURE_SCHEDULES)}
            >
              <UI.Radio
                selected={selectedOption === RepeatReservationDeleteOption.THIS_SCHEDULE_AND_FUTURE_SCHEDULES}
              />
              <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
                이 일정 및 향후 일정
              </UI.Typography>
            </OptionItem>
            <OptionItem onClick={() => setSelectedOption(RepeatReservationDeleteOption.ALL_SCHEDULES)}>
              <UI.Radio selected={selectedOption === RepeatReservationDeleteOption.ALL_SCHEDULES} />
              <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
                모든 일정
              </UI.Typography>
            </OptionItem>
          </Options>
          <Btns>
            <UI.Button size="large" onClick={closeModal} title="취소하기" type="outlined" style={{ width: "100%" }} />
            <UI.Button size="large" onClick={handleDelete} title="삭제하기" type="solid" style={{ width: "100%" }} />
          </Btns>
        </Section>
      </Container>
    </Modal>
  );
}
